/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdTransferProps } from './type';

export const transferDefaultProps: TdTransferProps = {
  defaultChecked: [],
  data: [],
  direction: 'both',
  search: false,
  showCheckAll: true,
  targetSort: 'original',
  title: [],
  defaultValue: [],
};
